import React from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import TrashCan from '@wix/da-ds/pkg/Icons/24x24/Trashcan';

interface Props {
  disabled?: boolean;
  onRemoveAttachment: () => void;
}

export const RemoveAttachmentButton: React.FC<Props> = ({ disabled, onRemoveAttachment }) => {
  const { t } = useTranslation();
  return (
    <TextButton
      variant="main"
      size="medium"
      icon={TrashCan}
      disabled={disabled}
      onClick={onRemoveAttachment}
    >
      {t('deviationSubmit.form.removeAttachment.button.text')}
    </TextButton>
  );
};
RemoveAttachmentButton.displayName = 'RemoveAttachmentButton';

export default RemoveAttachmentButton;
